import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from './components/ui/Toast.js';
import { ProtectedRoute } from './components/layout/ProtectedRoute.js';
import { AdminRoute } from './components/layout/AdminRoute.js';
import HomePage from './pages/HomePage.js';
import LoginPage from './pages/LoginPage.js';
import RegisterPage from './pages/RegisterPage.js';
import LobbyPage from './pages/LobbyPage.js';
import RoomPage from './pages/RoomPage.js';
import NotFoundPage from './pages/NotFoundPage.js';
import AdminLayout from './pages/admin/AdminLayout.js';
import AdminDashboardPage from './pages/admin/AdminDashboardPage.js';
import AdminDomainsPage from './pages/admin/AdminDomainsPage.js';
import AdminInvitesPage from './pages/admin/AdminInvitesPage.js';
import AdminAccessPage from './pages/admin/AdminAccessPage.js';
import AdminUnauthorizedPage from './pages/admin/AdminUnauthorizedPage.js';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/r/:slug" element={<LobbyPage />} />
          <Route path="/r/:slug/room" element={<RoomPage />} />
        </Route>

        {/* Admin routes — protected by CF Access JWT + internal_users */}
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="domains" element={<AdminDomainsPage />} />
            <Route path="invites" element={<AdminInvitesPage />} />
            <Route path="access" element={<AdminAccessPage />} />
          </Route>
        </Route>

        {/* Standalone admin page — outside AdminRoute guard, no app session needed.
            Reached when CF Access auth passes but email isn't in internal_users. */}
        <Route path="/admin/unauthorized" element={<AdminUnauthorizedPage />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}
